// extracted by mini-css-extract-plugin
module.exports = {"corpo":"Consultar_corpo__2hVXK","tituloCard":"Consultar_tituloCard__JeAfW"};